import $ from '@ali/tarzan-zepto';
import IScroll from 'iscroll';
import moment from 'moment';
import util from '../../../lib/util.js';
import BaseUI from '../../../component/baseui/index';
import tpl from './tpl.html';
import pop from './list.html';
import './style.scss';

let App = null;

const TAP = util.isPC() ? 'click' : 'tap';

function __show($node, cb) {
  // 向下滑,隐藏知识浮层
  setTimeout(() => {
    $node.find('.layer-body').addClass('slideUp');
    setTimeout(() => {
      cb();
    }, 350);
  }, 10);
}

function __hide($node) {
  $node.find('.J_Layer').removeClass('slideUp');
  setTimeout(() => {
    $node.remove();
  }, 320);
}

function __bindEvent($node) {
  $node.find('.layer-mask').on(TAP, () => {
    __hide($node);
  });
  $node.find('.layer-close').on(TAP, () => {
    __hide($node);
  });
}

// // pop up
function popUp(list) {
  list.title = App.util.lang.get('packageOrder')(
    list.sortIndex,
    list.sortLength,
  );
  const $node = $(pop.render(list));
  $('.m-alicare').append($node);
  $node.find('.layer-mask').animate(
    {
      opacity: 1,
    },
    300,
  );
  $node.find('.layer-mask').on(TAP, (ev) => {
    ev.preventDefault();
  });
  __show($node, () => {
    __bindEvent($node);
  });
}

function initScroll(data, $node) {
  const num = data.list.length;
  const prev = $node.find('.prev');
  const next = $node.find('.next');
  const order = $node.find('.m-chatpanel-option-button');
  const pics = $node.find('.order-items');

  if (num === 1) {
    next.hide();
  }

  $node.find('.J_Orderlist').css({
    width: 274,
    maxHeight: 198,
  });

  $node.find('.J_Order').css({
    width: 218,
  });

  $node.find('.J_Scroller').css({ width: 230 * num });

  const scroller = new IScroll($node.find('.J_Orderlist')[0], {
    scrollX: true,
    scrollY: false,
    momentum: false,
    snap: 'div.J_Order',
  });

  scroller.on('scrollEnd', () => {
    const len = scroller.pages.length;
    const index = scroller.currentPage.pageX;
    if (index === 0) {
      prev.hide();
      next.show();
    } else if (index === len - 1) {
      next.hide();
      prev.show();
    } else {
      prev.show();
      next.show();
    }
  });
  // 事件绑定
  next.on(TAP, () => {
    scroller.next();
  });
  prev.on(TAP, () => {
    scroller.prev();
  });
  order.on(TAP, (ev) => {
    const $target = $(ev.currentTarget);
    const value = $target.attr('data-value');
    const action = $target.attr('data-action');
    // if ($target.hasClass('disabled')) return;
    // order.addClass('disabled');
    App.view.footer.submit({ q: value, ext: { botJson: action } });
  });

  pics.on(TAP, (ev) => {
    const $target = $(ev.currentTarget);
    const i = $target.attr('data-index');
    data.list[i - 1].sortIndex = i;
    data.list[i - 1].sortLength = data.list.length;
    popUp(data.list[i - 1]);
  });
}

export default function orderlist(data) {
  App = this;
  const orderList = data.body.list;
  orderList.map((item, index) => {
    item.button.action = JSON.stringify(item.button.action);
    item.date = moment(item.date).format('MMM Do');
    item.langOrder = this.util.lang.get('indexOrder')(
      index + 1,
      orderList.length,
    );
    item.langOrderDetail = this.util.lang.get('orderDetail')(
      item.number,
      item.date,
      item.items.length,
    );
    return item;
  });
  const $wrap = $('<div class="m-chapanel-orderwrap"></div>');
  const openOrderType =
    data.body.intentFlow === 'cancellation' ? 'openOrderToCancel' : 'openOrder';
  const tem = tpl.render({
    list: orderList,
    openOrder: this.util.lang.get(openOrderType)(orderList.length),
    showAll: this.util.lang.get('SHOW:ALLORDERS'),
  });
  const param = {
    name: 'orderlist',
    mid: '11',
    content: tem,
  };
  const $node = $(BaseUI.msg(param));

  setTimeout(() => {
    $wrap.append($node);
    if (orderList.length === 0) {
      this.view.body.scrollToBottom();
    } else {
      initScroll(data.body, $wrap);
      this.view.body.scrollToBottom();
    }
  }, 0);

  $node.find('.orderlist-showall').on(TAP, () => {
    const link = document.createElement('a');
    link.href = App.param.myOrdersLink || data.body.redirectLink;
    link.target = '_blank';
    link.click();
    $(link).remove();
  });

  return {
    body: $wrap,
    callback: () => {},
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/orderlist/index.js